import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	firstName: {
		id: 'generics.firstName',
		defaultMessage: 'First Name',
		description: 'First Name input field',
	},
	firstNameError: {
		id: 'profile.accountDetails.firstNameError',
		defaultMessage: 'First name is not valid',
		description: 'An error shown when the user enters an invalid first name',
	},
	email: {
		id: 'profile.accountDetails.email',
		defaultMessage: 'Email',
		description: 'Email input field',
	},
	emailError: {
		id: 'profile.accountDetails.emailError',
		defaultMessage: 'Email is not valid',
		description: 'An error shown when the user enters an invalid email',
	},
	successTooltip: {
		id: 'profile.accountDetails.successTooltip',
		defaultMessage: 'Successfully updated account details!',
		description: 'A success message that shows the user their account information successfuly updated',
	},
	errorTooltip: {
		id: 'profile.accountDetails.errorTooltip',
		defaultMessage: 'Error updating account details!',
		description: "A generic error saying the user wasn't able to save account info",
	},
});
